import { Box, DialogContent, DialogTitle } from "@mui/material";
import { rolePermissionsBusiness } from "api/bussiness/user-role-permission/role-permission-bussiness";
import { UpdateRole } from "api/models/request/user-role/roles";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { observer } from "mobx-react-lite";
import { useCallback } from "react";
import { string } from "yup";
import { DynamicForm } from "../../../../commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "../../../../commons/ultilities/dynamic-form/hooks/use-form";
import { useStores } from "../../../../mobx-stores/_root-store";
import { DialogForm } from "../../../../share-components/templates/form/dialog-form";

export const EditRole = observer(() => {
  const {
    rolePermissionManagement: { openEdit, setProp, roleSelected, replaceRole },
  } = useStores();
  const {
    form: { controls, isValid, isDirty },
    submitHandler,
  } = useForm<UpdateRole>(
    {
      name: {
        gridSize: 12,
        label: "Tên vai trò",
        type: InputType.text,
        validattionYupSchema: string().required().max(256),
      },
      // isDefault: {
      //   gridSize: 12,
      //   label: "Mặc định",
      //   type: InputType.checkbox,
      // },
    },
    {
      name: roleSelected?.name || "",
      isDefault: roleSelected?.isDefault || false,
      isPublic: false,
    }
  );

  const saveHandler = useCallback(
    async (data: UpdateRole) => {
      if (!roleSelected?.id) return;

      const res = await rolePermissionsBusiness.updateRole(
        roleSelected?.id,
        data
      );
      replaceRole(res);
      setProp("roleSelected", null);
      setProp("openEdit", false);
    },
    [replaceRole, roleSelected?.id, setProp]
  );

  return (
    <DialogForm
      open={openEdit}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isDirty || !isValid,
      }}
    >
      <DialogTitle>Sửa vai trò</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
